import React from "react";
import "./DataScience1.css";

function DataScience1() {
  return (
    <div className="ds-main">

      <div className="container">
        <h1 className="ds-heading">Data Science</h1>

        {/* SECTION 1 */}
        <div className="ds-row">
          <div className="ds-img-box">
            <img src="service-pic/datascience-1.jpeg" alt="Big Data" />
            <div className="ds-overlay"></div>
          </div>

          <div className="ds-text-box">
            <h2>Big Data</h2>
            <p>
              We specialize in Big Data analysis by combining advanced tools
              with domain expertise. Our solutions help businesses transform
              raw data into meaningful insights and smarter decisions.
            </p>
          </div>
        </div>

        {/* SECTION 2 */}
        <div className="ds-row reverse">
          <div className="ds-img-box">
            <img src="service-pic/datascience-2.jpeg" alt="Cloud Computing" />
            <div className="ds-overlay"></div>
          </div>

          <div className="ds-text-box">
            <h2>Cloud Computing</h2>
            <p>
              Cloud technology enables flexibility, scalability and faster
              innovation. We help businesses adopt cloud strategies that reduce
              cost and improve performance.
            </p>
          </div>
        </div>

      </div>

    </div>
  );
}

export default DataScience1;